import { Component, OnInit, OnDestroy, ViewChild, ChangeDetectorRef, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs/Subject';
import { Store, Action } from '@ngrx/store';
import { Actions } from '@ngrx/effects';
import { Observable, Subscription } from 'rxjs';
import { SupportTicketModel } from '../models/SupportTicketModel';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { AutoSaveFormBuilder } from '../../pillar/workspace/AutoSaveFormBuilder';
import { AlertsComponent } from '../../pillar/alerts/components/alerts.component';
import { IUserContext } from '../store/state/IUserContext';
import { SupportTicketInformationModel } from '../models/SupportTicketInformationModel';
import * as securityActions from '../store/actions';
import * as fromStore from '../store/reducers';
import * as actions from '../../pillar/dashboard/store/actions';
import { ModuleConfiguration } from '../security.module.config';
import { LookupModel } from '../../common/models/LookupModel';
import { CurrentUserService } from '../../security/services/CurrentUserService';
import { GetCurrentUserSubmittingEntitiesAction } from '../../security/store/actions';
import { FileUploader, FileItem, ParsedResponseHeaders, FileLikeObject, FileUploaderOptions } from 'ng2-file-upload';
import { BaseAddressInterceptor } from '../../core/interceptors/BaseAddressInterceptor';
import { FileUploaderCustom } from '../../common/utilities/FileUploaderCustom';
import { getBrowserInfo } from '../../common/utilities/BrowserInformationHelper';

const URL = '/api/ConfigurationModule/SupportTicket/UploadFiles';

@Component({
  selector: 'brd-support-ticket-dialog',
  templateUrl: './support-ticket-dialog.component.html',
  styleUrls: ['./support-ticket-dialog.component.scss']
})
export class SupportTicketDialogComponent implements OnInit, OnDestroy {
  loading$: Observable<boolean>;
  errors$: Observable<string[]>;
  destroyed$: Subject<boolean> = new Subject<boolean>();
  userContext: IUserContext;
  userName: string;
  ticket: SupportTicketModel;
  supportTicketInformation: SupportTicketInformationModel;
  hasBaseDropZoneOver: boolean;
  submittingEntities$: Observable<LookupModel[]>;
  briefDescription: string;
  submitted: boolean;
  public uploader: FileUploaderCustom;

  allowSupportTicketSubmissionPermission: string = 'ConfigurationModule.SupportTicket:AllowSupportTicketSubmission';

  @ViewChild(AlertsComponent)
  alerts: AlertsComponent;
  constructor(private store: Store<any>,
    private formBuilder: FormBuilder,
    private actions$: Actions,
    private baseAddressInterceptor: BaseAddressInterceptor,
    public dialogRef: MatDialogRef<SupportTicketDialogComponent>,
    private curentUserService: CurrentUserService,
    @Inject(MAT_DIALOG_DATA) public data: IUserContext) { 
    }

  ngOnInit() {
    this.submitted = false;
    this.initTicket();
    this.store.dispatch(new securityActions.GetSupportTicketInformationAction());
    this.store
      .select(fromStore.getSupportTicketInformation)
      .takeUntil(this.destroyed$)
      .subscribe((v: SupportTicketInformationModel) => {
        if (v) {
          this.supportTicketInformation = v;
        }
      });

    this.submittingEntities$ = this.store.select(fromStore.getUserContextSubmittingEntities);
    this.store.select(fromStore.getUserContextSubmittingEntitiesLoaded)
      .takeUntil(this.destroyed$)
      .subscribe(() => {
        if (this.curentUserService.userContext.submittingEntitiesLoaded) {
          this.userContext = this.curentUserService.userContext;
          this.ticket = {
            ...this.ticket,
            username: this.userContext.claims['cognito:username'],
            userEmailAddress: this.userContext.claims.email,
            submittingEntities: this.userContext.submittingEntities.map(se => se.description)
          }
        } else {
          this.store.dispatch(new GetCurrentUserSubmittingEntitiesAction());
        }
      });

    this.uploader = new FileUploaderCustom({
      url: this.baseAddressInterceptor.getApiUrl(URL),
      headers: [{ name: 'X-Auth-Token', value: this.curentUserService.userContext.authToken }],
      filters: [
        {
          name: 'fileNameLength',
          fn: this.fileNameLengthFilter
        }
      ],
      queueLimit: 3
    });
    this.uploader.onBuildItemForm = (item, form) => {
      form.append('model', JSON.stringify(this.ticket));
    }
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
  }

  private removeFile( item: FileItem) {   
    var index = this.uploader.queue.indexOf(item, 0);
    if (index > -1) {
      this.uploader.queue.splice(index, 1);
    }
  }

  initTicket(): void {
    this.ticket = new SupportTicketModel();
    if(this.userContext)
    {
      this.ticket.username = this.userContext.claims['cognito:username'];
      this.ticket.userEmailAddress = this.userContext.claims.email;
      this.ticket.submittingEntities = this.userContext.submittingEntities.map(se => se.description);
    }
    this.ticket.dateAndTime = new Date();
    this.ticket.browser = getBrowserInfo();
    this.ticket.url = document.location.href;
    this.ticket.filePaths = [];
  }

  submit() {
    if (this.uploader.queue.length === 0) {
      this.store.dispatch(new securityActions.SubmitSupportTicketAction({ model: this.ticket }));
    } else {
      this.uploader.uploadAllFiles();
    }
    this.alerts.addSuccess("The support ticket has been submitted.");
    this.submitted = true;
    this.dialogRef.updateSize("auto", "auto");
    setTimeout(() => {
        this.dialogRef.close();
      },
      5000);
  }

  fileNameLengthFilter(item?: FileLikeObject, options?: FileUploaderOptions): boolean {
    return item.name.length <= 100;
  }

  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  onChange($event) {
    try {
      this.ticket.brieflyDescription = $event.currentTarget.value;
    } catch (ex) {
      console.info('Could not input description.');
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/security/components/support-ticket-dialog.component.ts